import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface DashboardStats {
  productionOrders: {
    total: number;
    imported: number;
    authorized: number;
    completed: number;
    created: number;
    backlog: number;
    planned: number;
    today: number;
    inProduction: number;
    ordersThisWeek: number;
    ordersThisMonth: number;
  };
  priorities: {
    high: number;
    medium: number;
    low: number;
  };
  quantities: {
    planned: number;
    proceso: number;
    merma: number;
    productoTerminado: number;
  };
  events: {
    total: number;
    today: number;
    thisWeek: number;
    withEvidence: number;
  };
  catalogs: {
    clients: number;
    equipment: number;
    activeEquipment: number;
  };
  users: {
    total: number;
    active: number;
  };
  manufacturing: {
    totalRoutes: number;
    totalEvidence: number;
    imageEvidence: number;
    textEvidence: number;
  };
  topClients: Array<{
    name: string;
    orders: number;
    quantity: number;
  }>;
  equipmentLoad: Array<{
    name: string;
    total: number;
    authorized: number;
    inProduction: number;
  }>;
  recentActivity: Array<{
    id: string;
    orderNumber: string;
    description: string;
    equipment: string | null;
    timestamp: string;
  }>;
}

export interface DateRangeParams {
  from?: string;
  to?: string;
}

export function useGetDashboardStats(dateRange?: DateRangeParams) {
  const from = dateRange?.from;
  const to = dateRange?.to;

  return useQuery({
    queryKey: ['dashboard', 'stats', from ?? '', to ?? ''],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (from) params.set('from', from);
      if (to) params.set('to', to);
      const qs = params.toString();
      const response = await axios.get<{ success: boolean; data: DashboardStats }>(
        `/api/dashboard/stats${qs ? `?${qs}` : ''}`
      );
      return response.data.data;
    },
    refetchInterval: 30000,
    staleTime: 10000,
  });
}
